<template>
  <v-content
  style="margin-top:80px"
  class="mx-5"
  >
      <v-col>
          <v-row
          justify="center"
          >
              <h2>AVISO DE PRIVACIDAD</h2>
              <p>
                En términos del artículo 16 de la ley de protección de datos 
                personales en posesión de los particulares, ObiPets, informa que es 
                responsable con respecto al titular de los datos, de recabar sus datos personales, 
                del uso que se le dé a los mismos y de su protección.
              </p>
              <p>
                  Su información personal será utilizada única y exclusivamente para el cumplimiento 
                  de contacto con el fin de adopción de los animales rescatados, ubicación de mascotas 
                  extraviadas y no de manera lucrativa.
              </p>
              <p>
                  Para las finalidades antes mencionadas, requerimos obtener del titular de los derechos, 
                  entre otros, los siguientes datos personales: Nombre Completo, Dirección, Código Postal, 
                  Teléfono de domicilio, celular y trabajo, así como correo electrónico, geo posición inmediata; 
                  datos no considerados como sensibles según la citada Ley.
              </p>
              <p>
                  Si usted no manifiesta su oposición para que sus datos personales sean tratados de acuerdo a los 
                  términos y condiciones de este Aviso de Privacidad, se entenderá que ha otorgado su consentimiento para ello.
              </p>
              <p>
                  Los datos personales serán mantenidos en estricta confidencialidad, de conformidad con las medidas de seguridad, 
                  administrativas, técnicas y físicas que ObiPets implemente en sus políticas y procedimientos de seguridad, 
                  quedando estrictamente prohibido su divulgación ilícita y limitando su uso a terceros, conforme a lo previsto 
                  en el presente Aviso de Privacidad. De acuerdo con lo anterior, sus datos personales pueden ser transferidos y 
                  tratados dentro de la República Mexicana y el extranjero, sin un fin comercial, sino únicamente en relación con 
                  la prestación de los servicios de ObiPets y si usted no manifiesta su oposición para que sus datos personales sean 
                  transferidos a terceros con el propósito arriba mencionado, se entenderá que ha otorgado su consentimiento para ello.
              </p>
              <p>
                  Usted, en términos del artículo 22 de la citada ley, en su carácter de titular de los derechos ARCO, podrá, acceder, 
                  rectificar y cancelar sus datos personales, así como de oponerse al tratamiento de los mismos o revocar el consentimiento 
                  que para tal fin nos haya otorgado, a través de los procedimientos que hemos implementado, o bien en términos de la multicitada, ley.
              </p>
              <p>
                  Así mismo, usted, como titular de los derechos, tendrá la facultad de cancelar sus datos en términos del artículo 25 de la citada ley, 
                  dando a ObiPets el aviso correspondiente en términos de la presente ley de protección de datos personales en posesión de los particulares.
              </p>
              <p>
                  Para conocer dichos procedimientos, los requisitos y plazos, se puede poner en contacto con nuestro departamento de datos personales en el 
                  correo electrónico  <a href="mailto:hola@obipets.com.mx">hola@obipets.com.mx</a> 
              </p>
              <p>
                  Cualquier modificación a este Aviso de Privacidad podrá consultar nuestra página de internet <a href="www.facebook.com/ObiPets"> www.facebook.com/ObiPets</a>.
              </p>
          </v-row>
      </v-col>
  </v-content>
</template>

<script>
export default {

}
</script>

<style>

</style>